import React from "react";
import { Eye, ChatCircle, Clock } from "@phosphor-icons/react";

export function TopicCard({ topic, onClick, formatDate }) {
  return (
    <div
      onClick={onClick}
      className="bg-white border border-[#E5E7EB] p-4 hover:border-[#0F766E] cursor-pointer transition-colors"
      data-testid={`topic-${topic.id}`}
    >
      <div className="flex items-center gap-2 mb-2">
        <span className="px-2 py-0.5 bg-[#F3F4F6] text-[#4B5563] text-[10px] font-mono uppercase">
          {topic.category}
        </span>
        {topic.region && topic.region !== "global" && (
          <span className="px-2 py-0.5 bg-[#E5E7EB] text-[#6B7280] text-[10px] font-mono uppercase">
            {topic.region}
          </span>
        )}
        {topic.is_pinned && (
          <span className="px-2 py-0.5 bg-[#FCD34D] text-[#92400E] text-[10px] font-mono uppercase">
            Pinned
          </span>
        )}
      </div>
      
      <h3 className="font-serif text-lg text-[#111827] line-clamp-2 mb-2">
        {topic.title}
      </h3>
      
      <p className="text-sm text-[#4B5563] line-clamp-2 mb-3">
        {topic.content}
      </p>
      
      <div className="flex items-center justify-between text-xs text-[#6B7280]">
        <span>{topic.author_name}</span>
        <div className="flex items-center gap-4">
          <span className="flex items-center gap-1">
            <Clock size={14} />
            {formatDate(topic.created_at)}
          </span>
        </div>
      </div>
    </div>
  );
}

export default TopicCard;
